module.exports = __webpack_public_path__ + "media/carefulWithThat.7cd41dea.mp3";